export default {
    parts: [
        'container',
        'title',
        'wrapper',
        'bigImageContainer',
        'contentContainer',
        'plCtaContainer',
        'modalContent'
    ],
    baseStyle: (props) => ({
        container: {
           paddingTop: {base: 6},
           paddingBottom: {base: 6},
           paddingLeft: {base: 0},
           paddingRight: {base: 0}
        },
        title: {
            fontSize: {base: 'md', lg: 'lg'},
            fontWeight: {base: 'bold'},
            lineHeight: {base: '100%'},
            marginBottom: {base: 3, lg: 6},
            textTransform: 'uppercase'
        },
        wrapper: {
           display: {base: 'flex'},
           flexDirection: {base: 'column', lg: props?.MediaPlacement === 'right' ? 'row-reverse' : 'row'},
           gap: {base: 3, lg: 2}
        },
        bigImageContainer: {
            flex: {lg: '0 0 calc(50% - 4px)'},
            maxWidth: {lg: 'calc(50% - 4px)%'},
            h: {lg: 'fit-content'},
            position: {lg: 'sticky'},
            top: {lg: '40px'}
        },
        bigImageWrapper: {
            position: 'relative'
        },
        contentContainer: {
            flex: {lg: '0 0 calc(50% - 4px)'},
            maxWidth: {lg: 'calc(50% - 4px)'}
        },
        plCtaContainer: {
            gridColumn: '1/-1',
            display: 'flex',
            justifyContent: 'center',
            marginTop: {base: 6, lg: 4}
        },
        modalContainer: {
            display: 'flex',
            flexDirection: 'column'
        },
        modalBody: {
            padding: {base: '48px 16px'}
        },
        closeBtn: {
            w: '24px',
            h: '24px',
            top: '12px',
            right: '16px',
            _hover: {
                backgroundColor: 'unset'
            }
        }
    }),
    variants: {
        'Grid': (props) => ({
            contentContainer: {
                display: {lg: 'grid'},
                gridTemplateColumns: {lg: 'repeat(2, 1fr)'},
                columnGap: {lg: 2},
                rowGap: {lg: 8}
            }
        }),
        'VerticalList': (props) => ({
            plCtaContainer: {
                marginTop: {base: 6, lg: 12}
            }
        }),
        'FullView': (props) => ({
            bigImageContainer: {
                flex: {base: '0 0 100%', lg: '0 0 100%'},
                maxWidth: {base: '100%', lg: '100%'},
                position: {lg: 'relative'}
            }
        }),
    }
}
